import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './IsExclusiveNote.scss';

interface Props {}

const IsExclusiveNote: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <InfoIcon className={s['info-icon']} size={IconSize.SMALLER} disableDefaultColors />

      {t('deviationSubmit.form.attachments.isExclusiveNote')}
    </div>
  );
};
IsExclusiveNote.displayName = 'IsExclusiveNote';

export default IsExclusiveNote;
